import CarPeritajeReportEntity, { PeritajeSource } from "../../../../../domain/entities/CarPeritajeReportEntity";

const SEPARATOR = ";";
/** Excel en es-CO no detecta UTF-8 sin BOM y rompe las tildes. */
const BOM = "﻿";

const HEADERS = [
    "id",
    "placa",
    "vehiculo",
    "marca",
    "linea",
    "version",
    "anio",
    "tipo",
    "sede",
    "etiqueta",
    "kilometraje",
    "precio",
    "tiene_peritaje",
    "fuente_peritaje",
    "pdf_automas",
    "id_colserauto",
    "automas_api",
    "colserauto_api",
    "url",
];

const SOURCE_LABELS: Record<PeritajeSource, string> = {
    automasPdf: "Automás (PDF cargado)",
    automasApi: "Automás (API por placa)",
    colserautoPdf: "Colserauto (PDF por id)",
    colserautoApi: "Colserauto (API por placa)",
};

const escape = (value: unknown): string => {
    const text = value == null ? "" : String(value);
    return /["\n\r;]/.test(text) ? `"${text.replace(/"/g, '""')}"` : text;
};

const toRow = (car: CarPeritajeReportEntity, origin: string): unknown[] => [
    car.id,
    car.plate,
    car.name,
    car.brand,
    car.line,
    car.version,
    car.year,
    car.type,
    car.sede,
    car.tag,
    car.mileage,
    car.price,
    car.source ? "Si" : car.checkFailed ? "Error de consulta" : "No",
    car.source ? SOURCE_LABELS[car.source] : "",
    car.hasAutomasPdf ? "Si" : "No",
    car.hasColserautoId ? "Si" : "No",
    car.hasAutomasApi ? "Si" : "No",
    car.hasColserautoApi ? "Si" : "No",
    `${origin}${car.detailPath}`,
];

export const buildPeritajeCsv = (cars: CarPeritajeReportEntity[], origin: string): string =>
    BOM +
    [HEADERS, ...cars.map((car) => toRow(car, origin))].map((row) => row.map(escape).join(SEPARATOR)).join("\r\n");

/** Nombre con fecha para que descargas de días distintos no se pisen en la carpeta de descargas. */
export const peritajeCsvFileName = (date: Date = new Date()): string =>
    `vehiculos-activos-peritaje-${date.toISOString().slice(0, 10)}.csv`;

export const downloadCsv = (fileName: string, content: string): void => {
    const blob = new Blob([content], { type: "text/csv;charset=utf-8;" });
    const url = URL.createObjectURL(blob);
    const link = document.createElement("a");

    link.href = url;
    link.download = fileName;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    URL.revokeObjectURL(url);
};
